<div class="form-container__form-field flex flex-col">
  <mat-label class="label mb-1 form-container__form-field__label" [ngClass]="{'text-danger mat-form-field-invalid' : aFormControl.invalid && aFormControl.touched, 'text-disabled' : aFormControl.disabled}">{{ label || '' }}</mat-label>
  <mat-form-field class="w-full">
    <mat-select [formControl]="aFormControl" multiple>
      <mat-option *ngFor="let user of users" [value]="user.id">{{ user.name }}</mat-option>
    </mat-select>
  </mat-form-field>
  <app-control-error [control]="aFormControl"></app-control-error>
</div>
